/**
 * Interruptores de build del frontend (ola 3 · M2).
 *
 * Todas las piezas de la ola 3 que dependen de una variable `REACT_APP_*_ENABLED`
 * van ENCENDIDAS por defecto: el entorno (Vercel, `.env`) solo puede apagarlas con
 * `'false'`, `'0'` u `'off'`. Cualquier otro valor, o la variable sin definir, deja
 * el interruptor encendido. El servidor tiene sus propios flags y el frontend lo
 * consulta donde toca (`/exam/config.anxiety_enabled`, `/api/study/free-recall/pending`,
 * `/api/dosis/estado`): con el backend apagado nada cambia para la alumna.
 *
 * Se lee en cada llamada, no al cargar el módulo: CRA incrusta `process.env` en el
 * build y en jest `process.env` es dinámico, así cada test fija el valor que quiere.
 */

const OFF_VALUES = ['false', '0', 'off'];
const ON_VALUES = ['true', '1', 'on'];

// Sin guarda `typeof process`: en el navegador no existe `process`, pero CRA sustituye la
// expresión `process.env` por un objeto literal en el build (el acceso dinámico `[name]`
// funciona sobre ese objeto). Si no hubiera sustitución, el ReferenceError cae al default.
const readEnv = (name) => {
  try {
    return process.env[name];
  } catch (_e) {
    return undefined;
  }
};

/**
 * `flagOn('REACT_APP_X_ENABLED')` → true salvo que el entorno diga 'false' / '0' / 'off'.
 * Con `defaultValue = false` (p. ej. `REACT_APP_OFFLINE_ENABLED`) solo enciende 'true' / '1' / 'on'.
 */
export const flagOn = (name, defaultValue = true) => {
  const raw = readEnv(name);
  if (raw === undefined || raw === null) return defaultValue;
  const valor = String(raw).trim().toLowerCase();
  if (valor === '') return defaultValue;
  if (OFF_VALUES.includes(valor)) return false;
  if (ON_VALUES.includes(valor)) return true;
  return defaultValue;
};

/** Interruptores de la ola 3 (encendidos por defecto). */
export const FLAGS = Object.freeze({
  FREE_RECALL: 'REACT_APP_FREE_RECALL_ENABLED',
  THREE_OPTIONS: 'REACT_APP_THREE_OPTIONS_ENABLED',
  ANSWER_CUES: 'REACT_APP_ANSWER_CUES_ENABLED',
  EXAM_ANXIETY: 'REACT_APP_EXAM_ANXIETY_ENABLED',
  DOSIS: 'REACT_APP_DOSIS_ENABLED',
  REST_SCREEN: 'REACT_APP_REST_SCREEN_ENABLED',
});

export default flagOn;
